export default /* glsl */`
precision highp float;

uniform float viewportWidth;
uniform float viewportHeight;
uniform vec3 color0;
uniform vec3 color1;
uniform float ratio0;
uniform float ratio1;
uniform float rotate;
uniform float opacity;
uniform float sizeX;
uniform float sizeY;
varying vec2 vUv;

uniform vec3 fogColor;
uniform float fogNear;
uniform float fogFar;


highp vec3 smoothstepvec3(vec3 color0, vec3 color1, float edge0, float edge1, float x) {
    highp float ratio = smoothstep(edge0, edge1, x);
    return mix(color0, color1, ratio);
}

highp float smoothstepFloat(float val0, float val1, float edge0, float edge1, float x) {
    highp float ratio = smoothstep(edge0, edge1, x);
    return mix(val0, val1, ratio);
}

mat3 rotationMat(float rotate) {
    float aRad = radians(rotate);
    float cosA = cos(aRad);
    float sinA = sin(aRad);
    return mat3(
        cosA, -sinA, 0.0,
        sinA, cosA, 0.0,
        0.0, 0.0, 1.0
    );
}

void main() {

    float size = viewportWidth * cos(rotate) + viewportHeight * sin(rotate);
    size = min(viewportWidth, viewportHeight);
    vec3 sizesVec = vec3(size, size, 1.0);
    vec3 relFragCoord = (gl_FragCoord.xyw - 0.5 * vec3(viewportWidth, viewportHeight, 0.0)) / sizesVec;

    vec3 transformedFragCoord = relFragCoord;
    transformedFragCoord = rotationMat(rotate) * transformedFragCoord;
    transformedFragCoord += vec3(0.5);

    float gradientRatio = transformedFragCoord.y;

    float ratio1 = ratio1;
    float ratio = ratio0;
    vec3 color1 = color1;
    highp vec3 color = color0;
    bool needStep = false;

    if (ratio1 > 0.0 && gradientRatio > ratio) {
        if (gradientRatio > ratio1) {
            ratio = ratio1;
            color = color1;
        } else {
            needStep = true;
        }
    }

    if (needStep) {
        color = smoothstepvec3(color, color1, ratio, ratio1, gradientRatio);
    }

    float alpha = opacity;

    vec2 uvInner = (vUv - 0.25) * 2.0;

    // Draw inside the arc area
    if (uvInner.x > 0.0 && uvInner.x < 1.0 && uvInner.y > 0.0 && uvInner.y < 1.0) {
        float relToCenterX = abs(uvInner.x - 0.5) * 2.0;
        float relToCenterY = abs(uvInner.y - 0.5) * 2.0;
        float alphaXBox = 0.0;
        float alphaYBox = 0.0;
        float alphaX = 1.0;
        float alphaArc1 = 0.0;
        float edge = 0.0;
        float widthEdge = 0.002;

        // Far left and right bondaries
        edge = 1.0 - widthEdge;
        if (relToCenterX > edge) {
            alphaXBox = smoothstepFloat(0.0, 1.0, edge, 1.0, relToCenterX);
        }
        if (relToCenterY > edge) {
            alphaYBox = smoothstepFloat(0.0, 1.0, edge, 1.0, relToCenterY);
        }

        // The Central part: 320 of 409
        float centerRelW = 0.78;
        float centerHalfW = centerRelW * sizeX * 0.5;
        float arcRadiusRelToY = centerHalfW / sizeY;

        vec2 vecToCentralTop = vec2(relToCenterX * sizeX * 0.5, (uvInner.y - 1.0 + arcRadiusRelToY) * sizeY);
        float distance = length(vecToCentralTop);

        if (relToCenterX < centerRelW) {
            edge = centerRelW - widthEdge;
            alphaX = smoothstepFloat(0.0, 1.0, edge, centerRelW, relToCenterX);

            edge = centerHalfW - 0.1;
            if (uvInner.y > 1.0 - arcRadiusRelToY && distance > edge) {
                alphaArc1 = smoothstepFloat(0.0, 1.0, edge, centerHalfW, distance);
            }
        }

        // The Side parts: 358 of 409
        float sideFromX = 0.8753;
        // The Side parts top: 352 of 842
        float sideArcHeight = 0.42;

        if (relToCenterX > sideFromX) {
            edge = sideFromX + widthEdge;
            alphaX = smoothstepFloat(1.0, 0.0, sideFromX, edge, relToCenterX);

            float relToSideX = abs(relToCenterX - 0.5 * sideFromX - 0.5);

            centerHalfW = (1.0 - sideFromX) * 0.5 * sizeX * 0.5;
            arcRadiusRelToY = centerHalfW / sizeY;

            vecToCentralTop = vec2(relToSideX * sizeX * 0.5, (uvInner.y - sideArcHeight + arcRadiusRelToY) * sizeY);
            distance = length(vecToCentralTop);

            edge = centerHalfW - 0.1;
            if (uvInner.y > sideArcHeight - arcRadiusRelToY && distance > edge) {
                alphaArc1 = smoothstepFloat(0.0, 1.0, edge, centerHalfW, distance);
            }
        }

        alpha *= alphaXBox + alphaYBox + alphaX + alphaArc1;
    }

    #ifdef ALPHATEST

        if ( alpha < ALPHATEST ) discard;

    #endif

    gl_FragColor = vec4(color, alpha);


    #ifdef USE_FOG
          #ifdef USE_LOGDEPTHBUF_EXT
              float depth = gl_FragDepthEXT / gl_FragCoord.w;
          #else
              float depth = gl_FragCoord.z / gl_FragCoord.w;
          #endif
          float fogFactor = smoothstep( fogNear, fogFar, depth );
          gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );
      #endif
    if (gl_FragColor.a < 0.0001) discard;
}
`;
